import React, { useState } from 'react';

const ReportButton = ({ itemCode, storeId, chain, price, itemName }) => {
  const [status, setStatus] = useState('idle'); // 'idle' | 'loading' | 'done'

  const handleReport = async (e) => {
    e.stopPropagation();
    if (status !== 'idle') return;
    setStatus('loading');
    try {
      await fetch('/api/report-price', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ itemCode, storeId, chain, price, itemName }),
      });
      setStatus('done');
      setTimeout(() => setStatus('idle'), 2000);
    } catch (_) {
      setStatus('idle');
    }
  };

  if (status === 'done') {
    return (
      <span style={{ fontSize: '0.75em', color: '#1c7a3b', marginLeft: 6, whiteSpace: 'nowrap' }}>
        Reported
      </span>
    );
  }

  return (
    <button
      onClick={handleReport}
      disabled={status === 'loading'}
      title="Report suspicious price"
      style={{
        background: 'none',
        border: 'none',
        padding: '0 4px',
        cursor: 'pointer',
        fontSize: '0.8em',
        color: '#999',
        lineHeight: 1,
        marginLeft: 4,
        opacity: status === 'loading' ? 0.5 : 1,
      }}
    >
      🚩
    </button>
  );
};

export default ReportButton;
